import Footer from "../Components/Footer";
import ImageGallery from "./ImageGallery";
import GalleryHeader from "./Header";
import Decision from "../Components/Decision";
import { useRecoilValue } from "recoil";
import { pageDetails } from "../Recoil/ActiveEvents";
export default function Gallery() {
  const selectedEvent = useRecoilValue(pageDetails);
    return (
      <div>
        <GalleryHeader eventID = {selectedEvent.selectedEID}/>
        <ImageGallery />
        <Decision/>
        <Footer />
      </div>
    );
  }